import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import Utility from '../../util/utilityfunctions';

export default function PICFilterReducer(state = initialState.picTaskListFilters, action) {
	switch (action.type) {
		case types.SET_PIC_MENU_FILTERS: {
			let filters = {...state};

			Object.entries(action.filters).forEach((level) => {
				filters[action.filterKey] = {
					...filters[level[0]],
					...level[1]
				};
			});

			return filters;
		}

		case types.SET_PIC_MENU_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, explicit undefined is required
				value = null;
			}

			let filters = {...state};
			if (action.filterKey) {
				if (filters[action.filterKey]) {
					filters[action.filterKey] = {...filters[action.filterKey]};
				} else {
					filters[action.filterKey] = {};
				}

				filters[action.filterKey][action.filterItemName] = value;

				if (!Utility.hasValue(filters[action.filterKey][action.filterItemName])) {
					delete filters[action.filterKey][action.filterItemName];
				}
			} else {
				filters[action.filterItemName] = value;
			}

			return {
				...state,
				...filters,
				refresh: true
			};
		}

		case types.SET_PIC_FILTERS: {
			let filters = {...state};
			if (action.filterKey) {
				filters[action.filterKey] = {...action.filters};
			}
			return {...filters, ...action.mainFilters, refresh: true};
		}

		case types.SET_PIC_SEARCH_FILTER: {
			return {...state, ...action.filters, refresh: action.refresh};
		}

		case types.SET_PIC_MULTIPLE_MENU_FILTER: {
			let filters = {...state};
			if (action.filterKey) {
				filters[action.filterKey] = {...action.filters};
			}
			filters = {...filters, ...action.resetfilters, refresh: true};
			return filters;
		}

		case types.UPDATE_PIC_BASIC_FILTERS: {
			let filters = {...state, ...action.filter, refresh: true};
			return filters;
		}

		case types.CLEAR_PIC_FILTERS: {
			let filters = {...state};
			filters[action.filterKey] = {};
			return {...filters, refresh: true};
		}
		default:
			return state;
	}
}
